import {bzIconChevronUp} from "@bringoz/ui/icons";

require("./package-details-settings-panel-content.scss");

import {ChangeDetectionStrategy, Component, inject, output, signal} from "@angular/core";
import * as _ from "lodash";
import {PANEL_DATA} from "../../services/panel.service";
import {TableColumnsSettings} from "../bringoz-table-columns-settings/bringoz-table-columns-settings.component";

export interface PackageDynamicColumn {
  id: string;
  title?: string;
  enabled?: boolean;
  permission?: string | string[];
}

export interface PackageDetailsSettings {
  columns?: TableColumnsSettings;
  packageDynamicColumns?: PackageDynamicColumn[];
}

export interface PackageDetailsSettingsPanelData {
  settings: PackageDetailsSettings;
  defaultColumns: TableColumnsSettings;
}

@Component({
  selector: "app-package-details-settings-panel-content",
  templateUrl: "./package-details-settings-panel-content.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackageDetailsSettingsPanelContentComponent {
  private readonly data = inject<PackageDetailsSettingsPanelData>(PANEL_DATA);
  readonly onClose = output<PackageDetailsSettings | undefined>();

  readonly settings = signal<PackageDetailsSettings>({
    columns: _.cloneDeep(this.data.settings.columns),
    packageDynamicColumns: _.cloneDeep(this.data.settings.packageDynamicColumns),
  });

  onColumnsChange(columns: TableColumnsSettings): void {
    this.settings.update((s) => ({...s, columns}));
  }

  readonly chevronUp = bzIconChevronUp;

  onPackageColumnToggle(index: number, enabled: boolean): void {
    this.settings.update((s) => ({
      ...s,
      packageDynamicColumns: s.packageDynamicColumns.map((column, i) => (i === index ? {...column, enabled} : column)),
    }));
  }

  onReset(): void {
    this.settings.set({columns: this.data.defaultColumns});
    this.onSubmit();
  }

  onSubmit(): void {
    this.onClose.emit(this.settings());
  }

  onCancel(): void {
    this.onClose.emit(undefined);
  }
}

